var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "top",
            "label-width": "auto",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: "The contact will expire from this group in X days",
                prop: "expiry_period",
              },
            },
            [
              _c("el-input-number", {
                attrs: { precision: 0, min: 1 },
                model: {
                  value: _vm.form.expiry_period,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expiry_period", $$v)
                  },
                  expression: "form.expiry_period",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          { staticClass: "btn btn-create", on: { click: _vm.store } },
          [_vm._v("Save")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }